import { defaultColor, type Stroke } from '@bynder-studio/misc';
import useAccessRights from 'packages/hooks/useAccessRights';
import { ActiveSplits } from 'packages/store/user/types';

const useOutlineSettingDefaults = (stroke: Stroke): Partial<Stroke> => {
    const { isSplitEnabled } = useAccessRights();

    return isSplitEnabled(ActiveSplits.studioTextOutlineColor)
        ? { strokeColor: stroke.strokeColor ?? defaultColor, punchOut: stroke.punchOut ?? false }
        : {};
};

export default useOutlineSettingDefaults;
